/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import uploadPublicProjectFileActions, {
    uploadPublicProjectFileTypes,
} from '../../../redux/collectData/uploadProjetPublic'
import getPublicProjectHistoryActions from '../../../redux/collectData/getPublicProjectHistory'
import { Post } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* uploadPublicProjectFileSagas({ response }) {
    try {
        const res = yield Post(`csv/project_data`, response.fileData)
        if (res.status === 200) {
            yield all([
                yield put(
                    uploadPublicProjectFileActions.uploadPublicProjectFileSuccess(
                        res.data
                    )
                ),
                yield put(
                    getPublicProjectHistoryActions.getPublicProjectHistoryRequest()
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: null,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
            ])
        } else {
            yield put(
                uploadPublicProjectFileActions.uploadPublicProjectFileFailure(
                    res
                )
            )
        }
    } catch (error) {
        yield put(
            uploadPublicProjectFileActions.uploadPublicProjectFileFailure(error)
        )
    }
}

export function* uploadPublicProjectFileSaga() {
    yield takeLatest(
        uploadPublicProjectFileTypes.UPLOAD_PUBLIC_PROJECT_FILE_REQUEST,
        uploadPublicProjectFileSagas
    )
}
